module.exports = __webpack_public_path__ + "static/media/border_value_icon.a9dd04fa.svg";